<template>
  <Card class="trade-order">
    <template slot="header">
      <div class="header flex align-center">
        <a class="pointer title mar-r5"> <span>订单处理</span> </a>
        <div class="pointer flex items-center" v-if="!isClick">
          <el-tooltip placement="bottom" effect="dark" :content="tooltip">
            <i class="el-icon-warning-outline gray6 f18 mar5-l"></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="items h140" v-loading="loading">
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}mj/order/manage/orderList.do?appid=1&tag=1`, '待客户支付-我的订单', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ orderInfo.orderStatus1 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待客户支付</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}mj/order/manage/orderList.do?appid=1&tag=2`, '待我发货-我的订单', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ orderInfo.orderStatus2 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待我发货</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}mj/order/manage/orderList.do?appid=1&tag=3`, '待客户确认-我的订单', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ orderInfo.orderStatus3 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待客户确认</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}mj/toIsPublicDisplayPriceMJ.do?appid=1`, '购买咨询', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ orderInfo.buyPurpose || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>购买咨询</span>
      </a>
      <a class="gray6 item" @click="$openHome(`${origin.VUE_APP_APP}v/aftersales/sellerList?appid=1`, '售后订单-我的订单', 0, isClick)">
        <span class="num" v-if="salesAuthority && shopId">{{ orderInfo.refundStatusCount || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>售后订单</span>
      </a>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "../../index.scss";
</style>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";

export default {
  components: {
    Card,
  },

  computed: mapState({
    defaultShop: (state) => state.app.defaultShop,
    salesAuthority: (state) => state.app.salesAuthority,
  }),

  data() {
    return {
      loading: true,
      tooltip: "抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限。",
      isClick: true,
      origin: process.env,
      orderInfo: {},
      shopId: "",
    };
  },

  mounted() {
    console.log("销售订单", this.salesAuthority, this.defaultShop);
    if (!this.salesAuthority) {
      this.isClick = false;
      this.loading = false;
      return;
    }
    const { shopIdStr, audit } = this.defaultShop;
    if (!shopIdStr || audit !== 1) {
      this.tooltip = "抱歉，您暂未开店或店铺正在审核中,请先开店或等待店铺审成功后再试。";
      this.isClick = false;
      this.loading = false;
      return;
    }
    this.shopId = shopIdStr;
    this.$store
      .dispatch("trade/shopOrderNum", {
        shop_id: shopIdStr,
      })
      .then((data) => {
        this.loading = false;
        this.orderInfo = {
          ...this.orderInfo,
          ...data,
        };
      });

    // 查询商品购买意向列表
    this.$store
      .dispatch("trade/queryBuyPurpose", {
        shopid: shopIdStr,
        pagenum: 1,
      })
      .then((data) => {
        this.orderInfo = {
          ...this.orderInfo,
          buyPurpose: data.totalCount,
        };
      });
  },
};
</script>
